__turbopack_context__.v({
  "container": "ZF0nVG_container",
  "container-img": "ZF0nVG_container-img",
  "content-text": "ZF0nVG_content-text",
  "image": "ZF0nVG_image",
  "title-eyebrow": "ZF0nVG_title-eyebrow",
});
